import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MapPin, Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 py-3">
          <Link to="/" className="flex items-center gap-2 w-fit">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <MapPin className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold text-xl">lokalnie.pro</span>
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="text-center max-w-md">
          <p className="text-6xl font-bold text-slate-200 mb-2">404</p>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Strona nie została znaleziona</h1>
          <p className="text-slate-500 mb-8">
            Adres, pod który trafiłeś, nie istnieje albo strona została przeniesiona.
          </p>
          <Button asChild>
            <Link to="/">
              <Home className="w-4 h-4 mr-2" /> Wróć na stronę główną
            </Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
